// import Swiper JS
import styles from './index.less';
import animate from '../../styles/animate.less';
import iconStyle from '../../styles/iconfont.less';
import $ from 'jquery';
import Modal from '../modal';

const defaultPrams = {
  imgList: [],
};
export default class RingsModal extends Modal {
  constructor(props) {
    super(props);
    this.hotspotId = 100;
    this.params = {
      ...defaultPrams,
      ...props,
    };
    this.dragImg = null;

    this._initContent();
  }
  _initContent() {
    this._addRings();
    // this._addNav();
    // this._addControles();
  }
  _addControles() {
    const $controle = $(`<div class="controles"></div>`);
    $controle.append(
      `<div class="controles-btn zoomin_btn"> <i class="${iconStyle['iconfont']}">&#xe628;</i> 放大</div>`,
    );
    $controle.append(
      `<div class="controles-btn zoomout_btn"> <i class="${iconStyle['iconfont']}">&#xe62a;</i> 缩小</div>`,
    );
    $controle.append(
      `<div class="controles-btn reset_btn"> <i class="${iconStyle['iconfont']}">&#xe621;</i> 重置</div>`,
    );
    this.$contentWrapper.append($controle);
  }
  _addRings() {
    const $ringsContainer = $(`<div class="${styles['rings-container']}">这里是环物</>`);
    this.$dom.append($ringsContainer);
  }
  _addNav() {
    // nav
    const $prevNav = $(
      `<div class="swiper-nav prev">
        <i class="${iconStyle['iconfont']}">&#xe66e;</i>
    </div>`,
    );
    const $nextNav = $(
      `<div class="swiper-nav next">
     <i class="${iconStyle['iconfont']}">&#xe66d;</i>
    </div>`,
    );
    this.$dom.append($prevNav);
    this.$dom.append($nextNav);
  }
}
